// extracted by mini-css-extract-plugin
export default {"omni-create-modal":"styles_omni-create-modal__-xsB-"};